import { createApiHook } from '../hooks';
import { reachEstimatorApiFactory } from './reachEstimatorApiFactory';

export const useReachEstimatorApi = createApiHook(reachEstimatorApiFactory);
